// API URL Configuration
export const API_BASE_URL =
  process.env.REACT_APP_API_URL || "http://localhost:5001";

export const buildApiUrl = (path = "") => `${API_BASE_URL}${path}`;
